export default function DestructionPolicy() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-gray-100 text-gray-900">
            <div className="max-w-3xl text-center bg-white p-8 rounded-lg shadow-lg">
                <h1 className="text-3xl font-bold mb-6">Destruction Policy</h1>
                <p className="text-lg leading-relaxed">
                    Arkenom Teknoloji destroys personal data using the following methods:
                </p>
                <ul className="mt-4 text-lg leading-relaxed text-left list-disc list-inside">
                    <li><strong>Physical Data Destruction:</strong> Shredders are used for document disposal.</li>
                    <li><strong>Digital Data Destruction:</strong> Data deletion or anonymization methods are applied.</li>
                </ul>
                <p className="mt-4 text-lg leading-relaxed">
                    Destruction processes are carried out every six months, and all relevant procedures are 
                    documented in written records.
                </p>
            </div>
        </div>
    );
}
